import {isInBucketData} from '../../utils/abacusHelper';

// Takes in state and returns pricingInfo json object
function getPricingInfoFromState(state) { // eslint-disable-line complexity
    const listing = state.listingReducer;
    const listingPage = state.listingPageReducer;

    const useGraphQl = isInBucketData(state.abacusTestsReducer || {}, 'ha_pdp_usePricingGraphQL');

    // PDS Pricing Info
    const pricingInfo = listingPage.pricingInfo || {};
    const listingObj = pricingInfo.get ? pricingInfo.get(listing.listingId) : null;
    const pdsDetails = listingObj ? listingObj.toJS() : {};
    pdsDetails.tripTotal = (((pdsDetails.pdpQuote || {}).quoteTotals || {}).total || {}).localized || null;
    // Graphql pricing details
    const priceDetails = listingPage.priceDetails && listingPage.priceDetails.toJS ? listingPage.priceDetails.toJS() : listingPage.priceDetails || {};
    const graphqlDetails = priceDetails.priceDetails || {totals: []};
    graphqlDetails.tripTotal = graphqlDetails.totals && graphqlDetails.totals.length ? graphqlDetails.totals[graphqlDetails.totals.length - 1].amount : '';

    return useGraphQl ? graphqlDetails : pdsDetails;
}

export default getPricingInfoFromState;
export {getPricingInfoFromState};
